'use client';

import { c as _c } from "react/compiler-runtime";
import { Pagination } from '@common/components/molecule/Pagination';
import { cn } from '@core/utils';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { type FestivalReviewListResponse, REVIEW_PAGE_SIZE } from '../../_utils/festivalFetchers';
import { FESTIVAL_SECTION_IDS } from '../_constants/sectionIds';
import { FestivalReviewCard } from './FestivalReviewCard';
interface FestivalReviewSectionProps {
  tourId: string;
  initialData?: FestivalReviewListResponse;
}
export const FestivalReviewSection = t0 => {
  const $ = _c(23);
  const {
    tourId,
    initialData
  } = t0;
  const [page, setPage] = useState(1);
  let t1;
  if ($[0] !== page || $[1] !== tourId) {
    t1 = UnauthQueryOptions["get:/wello/v1/allows/tour/festival/{tourId}/review"]({
      path: {
        tourId
      },
      query: {
        page,
        size: REVIEW_PAGE_SIZE
      }
    });
    $[0] = page;
    $[1] = tourId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = page === 1 ? initialData : undefined;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      ...t1,
      initialData: t2,
      placeholderData: keepPreviousData
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data,
    isPlaceholderData
  } = useQuery(t3);
  let t4;
  if ($[6] !== data?.context?.content) {
    t4 = data?.context?.content ?? [];
    $[6] = data?.context?.content;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const reviews = t4;
  const totalCount = data?.context?.totalElements ?? 0;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="font-600 text-Gray-black">후기</span>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== totalCount) {
    t6 = <h2 className="m-0 flex items-center gap-4 typo-h7">{t5}<span className="font-600 text-Gray-550">{totalCount}</span></h2>;
    $[9] = totalCount;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isPlaceholderData || $[12] !== reviews || $[13] !== tourId) {
    t7 = reviews.length === 0 ? <p className="m-0 rounded-small bg-Gray-25 px-16 py-32 text-center text-Gray-600 typo-body4">아직 등록된 후기가 없어요.<br />축제에 다녀오셨다면 첫 후기를 남겨주세요!</p> : <ul aria-busy={isPlaceholderData} className={cn("m-0 flex list-none flex-col gap-16 p-0 transition-opacity duration-200", isPlaceholderData && "opacity-60")}>{reviews.map(review => <FestivalReviewCard key={review.reviewId} tourId={tourId} review={review} />)}</ul>;
    $[11] = isPlaceholderData;
    $[12] = reviews;
    $[13] = tourId;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = nextPage => {
      setPage(nextPage);
      document.getElementById(FESTIVAL_SECTION_IDS.review)?.scrollIntoView();
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== page || $[17] !== totalCount) {
    t9 = <Pagination totalCount={totalCount} currentPage={page} size={REVIEW_PAGE_SIZE} onMovePage={t8} />;
    $[16] = page;
    $[17] = totalCount;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t7 || $[21] !== t9) {
    t10 = <section id={FESTIVAL_SECTION_IDS.review} className="scroll-mt-100"><div className="flex w-full flex-col gap-16 p-24">{t6}{t7}{t9}</div></section>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};